// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iview from 'iview'
import 'iview/dist/styles/iview.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router'
import 'swiper/css/swiper.min.css'
import 'lib-flexible'

Vue.use(iview)
Vue.use(ElementUI);
Vue.use(VueRouter)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    window.pageYOffset = 0
    next()
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>',
    mounted(){
        console.log('document宽度：'+document.body.clientWidth)
        window.clientWidth = document.body.clientWidth
    }
})



// WEBPACK FOOTER //
// ./src/main.js